import { HgSupportedLanguage } from '@smg-real-estate/domus';

import { GTMPageType } from '@/helpers/GTM/GTMParameters';

export const notFoundRoutes = () => {
  return [
    HgSupportedLanguage.DE,
    HgSupportedLanguage.EN,
    HgSupportedLanguage.FR,
    HgSupportedLanguage.IT,
  ].map((locale) => ({
    path: '/:pageNotFound*',
    name: `pageNotFound-${locale}`,
    component: () => import('@/components/HgPageNotFoundWrapper/HgPageNotFoundWrapper.vue'),
    meta: {
      locale: HgSupportedLanguage.DE,
      gtmPageType: GTMPageType.PAGE_NOT_FOUND,
      getLanguageSwitchLink(route: any) {
        return {
          name: `pageNotFound-${locale}`,
          query: route.query,
          params: route.params,
        };
      },
    },
  }));
};
